
export const DeploymentEnvironmentType=
{   
    publicNetwork:"publicNetwork",

    governmentNetWork:"governmentNetWork"
}   